import {
  BuyNGetMMarketingCampaignConfig,
  MarketingCampaignDiscountType,
  MarketingCampaignType,
  Offer,
  ProductDiscountMarketingCampaignConfig,
  ThresholdMarketingCampaignConfig,
} from '../../../../../../1_types/genericTypes';
import { pluralize } from '../../../../../../utils/string';

export const getTootltipTextFromOffer = (offer: Offer): string => {
  if (!offer) return null;
  switch (offer.type) {
    case MarketingCampaignType.BUY_ONE_GET_ONE_PRODUCT:
      return '1 acheté = 1 offert';
    case MarketingCampaignType.BUY_ONE_GET_ONE_DIFFERENT_PRODUCT:
      return '1 acheté = 1 cadeau offert';
    case MarketingCampaignType.PRODUCT_DISCOUNT:
      return `${(offer.config as ProductDiscountMarketingCampaignConfig).discount.value
        }% de réduction`;

    case MarketingCampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD:
      const config = offer.config as ThresholdMarketingCampaignConfig;
      return window.innerWidth > 1024 ? `-${config.discount.value}% à partir de ${config.threshold}€ d'achat` : `-${config.discount.value}% à partir de ${config.threshold}€`;

    case MarketingCampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT: {
      const bngmConfig = offer.config as BuyNGetMMarketingCampaignConfig;
      const numProductsPaid = bngmConfig.numProductsPaid ?? 0;
      const numProductsDiscounted = bngmConfig.numProductsDiscounted ?? 0;
      const discountValue = bngmConfig.discount?.value ?? 0;
      const isFullyDiscounted =
        bngmConfig.discount?.type === MarketingCampaignDiscountType.PERCENTAGE &&
        discountValue === 100;
      if (isFullyDiscounted) {
        return `${numProductsPaid} ${pluralize(numProductsPaid, 'acheté')}, ${numProductsDiscounted} ${pluralize(numProductsDiscounted, 'offert')}`;
      }
      const discountLabel =
        bngmConfig.discount?.type === MarketingCampaignDiscountType.CASH
          ? `-${discountValue}€`
          : `-${discountValue}%`;
      return `${numProductsPaid} ${pluralize(numProductsPaid, 'acheté')}, ${numProductsDiscounted} à ${discountLabel}`;
    }

    default:
      return null;
  }
};
